export default __webpack_public_path__ + "static/media/user.160493d5.png";